// extracted by mini-css-extract-plugin
module.exports = {"root":"TwoUp_root__N7GqD","slot":"TwoUp_slot__2x2zx"};